import React, { useContext } from 'react';
import TextField from '../engine/TextFieldEngine';
import FieldTitle from '../FieldTitle';
import styled from 'styled-components/macro';
import Description from '../Description';
import ParagraphField from '../engine/ParagraphFieldEngine';
import NumberField from '../engine/NumberFieldEngine';
import DropDownField from '../engine/DropDownFieldEngine';
import MultiSelectField from '../engine/MultiSelectFieldEngine';
import PhoneField from '../engine/PhoneFieldEngine';
import SingleChoiceField from '../engine/SingleChoiceFieldEngine';
import DateField from '../engine/DateFieldEngine';
import EmailField from '../engine/EmailFieldEngine';
import SectionBreakField from '../engine/SectionBreakFieldEngine';
import InstructionalTextField from '../engine/InstructionalTextFieldEngine';
import FileUploadField from '../engine/FileUploadFieldEngine';
import ConfirmationBox from '../engine/ConfirmationBoxEngine';
import LookupField from '../engine/LookupFieldEngine';
import ScoreField from '../engine/ScoreFieldEngine';
import AMLField from '../engine/AMLFieldEngine';
import LinkField from '../engine/LinkFieldEngine';
import log from '../../../utils/log';
import { FormContext } from '../FormContext';
import CurrencyConversionField from '../engine/CurrencyConversionFieldEngine';

export const FieldTypes = {
  text: TextField,
  long_text: ParagraphField,
  link: LinkField,
  number: NumberField,
  dropdown: DropDownField,
  multiple_choice: MultiSelectField,
  phone: PhoneField,
  yes_no: SingleChoiceField,
  currency: NumberField,
  date: DateField,
  email_address: EmailField,
  section_break: SectionBreakField,
  instructional_text: InstructionalTextField,
  file_upload: FileUploadField,
  confirmation: ConfirmationBox,
  currency_conversion: CurrencyConversionField,
  lookup: LookupField,
  user_lookup: LookupField,
  credas: AMLField,
  thirdfort: AMLField,
  worldcheck: AMLField,
  worldcheck_org: AMLField,
  score: ScoreField
};

const ErrorMsg = styled.p`
  padding: 0.8em 0;
  font-size: 14px;
  ${({ $uiType }) => {
    if ($uiType === 'instructional_text' || $uiType === 'section_break') {
      return 'padding: 0;';
    }
  }}
`;

const InternalAnchor = styled.a`
  position: relative;
  top: -160px;
`;

// const HiddenInput = styled.input`
//   // display: none;
// `;

const FieldView = props => {
  const { isFormReadOnly, isReadOnlyFieldsEditable } = useContext(FormContext);
  const FieldComponent = FieldTypes[props.uiType];

  return (
    <>
      {FieldComponent ? (
        <div
          onFocus={props.onFocus}
          className={props.classes}
          field-id={props.internalId}
          value={props.value}
        >
          <InternalAnchor id={'internal-link-' + props.internalId} />
          <FieldTitle
            title={props.title}
            isRequired={props.required}
            isReadOnly={props.readOnly}
            uiType={props.uiType}
            position={props.position}
            variant={props.variant}
          />
          {!props.ignoreDescription &&
            props.description &&
            (props.isUsingDescriptionLogic ? (
              props.description.map(d => (
                <Description
                  key={d.id}
                  fontSize={14}
                  content={d.description}
                  id={d.id}
                />
              ))
            ) : (
              <Description fontSize={14} content={props.description} />
            ))}
          <div onClick={props.onClick}>
            <FieldComponent
              {...props}
              readOnly={
                (isReadOnlyFieldsEditable ? false : props.readOnly) ||
                isFormReadOnly
              }
            />
          </div>
          <ErrorMsg $uiType={props.uiType} data-error={props.internalId} />
        </div>
      ) : null}
    </>
  );
};

export default FieldView;
